import { $ } from './../../helpers/query'
import {SectionAnimationTemplate} from './SectionAnimationTemplate'

export class IntroAnimation extends SectionAnimationTemplate {
  constructor() {
    super();
    this.introSection = document.querySelector('#intro-section');
    this.introDecor = this.introSection.querySelector('.intro__decoration');
    this.introCont = this.introSection.querySelector('.intro__container');
    this.introTitle = this.introSection.querySelector('.intro__title');
    this.introFeatures = this.introSection.querySelector('.intro__features');
    this.introBtns = this.introSection.querySelector('.intro__buttons');
    this.introAfterClone = this.clonePrevSibling(this.introSection.nextElementSibling);

    if (this.introAfterClone) {
      this.introAfterClone.querySelector('.intro__title').classList.remove('intro__title--down')
      this.introAfterClone.querySelector('.intro__features').classList.remove('intro__features--down')
      this.introAfterClone.querySelector('.intro__buttons').classList.remove('intro__buttons--down')
    }
  }

  // 1. Interract whith Previous section
  // -- 1.1. Interract forward
  onVisitDown() {
    const elemDelay = 400;
    this.videoBg.classList.add('bg-img--darken')
    this.videoBgImg.classList.add('bg-img--zoomed-max')
    setTimeout(() => {
      this.introTitle.classList.remove('intro__title--down')
      setTimeout(() => {
        this.introDecor.classList.remove('invisible')
        setTimeout(() => {
          this.introFeatures.classList.remove('intro__features--down')
          setTimeout(() => {
            this.introBtns.classList.remove('intro__buttons--down')
          }, elemDelay)
        }, elemDelay)
      }, elemDelay)
    }, this.ANIM_DUR + this.EXTRA_DUR)
    setTimeout(() => {
      window.dispatchEvent(this.transitionEnd)
    }, Math.max(this.TRANS_DUR, (elemDelay * 3 + this.ANIM_DUR)))
  }

  // -- 1.2. Interract back
  onLeaveUp() {
    window.dispatchEvent(this.transitionStart)
    this.videoBg.classList.remove('bg-img--darken')
    this.videoBgImg.classList.remove('bg-img--zoomed-max')
    this.introDecor.classList.add('invisible')
    this.introCont.classList.add('intro__container--down')
    setTimeout(() => {
      this.introCont.classList.remove('intro__container--down')
      this.introTitle.classList.add('intro__title--down')
      this.introFeatures.classList.add('intro__features--down')
      this.introBtns.classList.add('intro__buttons--down')
    }, this.ANIM_DUR + this.EXTRA_DUR)
  }

  // 2. Interract whith Next section
  // -- 2.1. Interract forward
  onLeaveDown() {
    window.dispatchEvent(this.transitionStart)
    this.videoBg.classList.add('invisible')
    this.videoBgImg.classList.add('bg-img--zoomed-extra-max')
    this.introDecor.classList.add('invisible')
    this.introCont.classList.add('intro__container--up')
    setTimeout(() => {
      this.videoBg.classList.add('hero-video--hidden')
      this.introDecor.classList.remove('invisible')
      this.introCont.classList.remove('intro__container--up')
    }, this.ANIM_DUR + this.EXTRA_DUR)
  }

  // -- 2.2. Interract back
  onVisitUp() {
    this.showVideo()
    this.introTitle.classList.remove('intro__title--down')
    this.introDecor.classList.remove('invisible')
    this.introFeatures.classList.remove('intro__features--down')
    this.introBtns.classList.remove('intro__buttons--down')
    if (this.introAfterClone) {
      this.introAfterClone.classList.remove('invisible')
      this.introAfterClone.querySelector('.intro__decoration').classList.remove('invisible')
      this.introAfterClone.querySelector('.intro__container').classList.add('intro__container--anim-up');
      setTimeout(() => {
        this.introAfterClone.classList.add('invisible')
        this.introAfterClone.querySelector('.intro__decoration').classList.add('invisible')
        this.introAfterClone.querySelector('.intro__container').classList.remove('intro__container--anim-up');
      }, this.ANIM_DUR + this.EXTRA_DUR)
    }
    setTimeout(() => {
      window.dispatchEvent(this.transitionEnd)
    }, this.TRANS_DUR)
  }
}
